// Polyfill for AbortSignal.timeout() — unavailable on older BrightSign Chromium builds.
export default function abortAfter(ms) {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
